// extracted by mini-css-extract-plugin
export default {"base":"Button_base__C1TT1","primary":"Button_primary__aburI","header":"Button_header__SNusM","outline":"Button_outline__K0-R3"};